import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckUserEventOnDayPromptCompletedQueryVariables = Types.Exact<{
  input: Types.CheckUserEventOnDayPromptCompletedInput;
}>;

export type CheckUserEventOnDayPromptCompletedQuery = {
  __typename?: 'Query';
  checkUserEventOnDayPromptCompleted: {
    __typename?: 'CheckUserEventOnDayPromptCompletedResponse';
    isCompleted: boolean;
  };
};

export const CheckUserEventOnDayPromptCompletedDocument = gql`
  query CheckUserEventOnDayPromptCompleted(
    $input: CheckUserEventOnDayPromptCompletedInput!
  ) {
    checkUserEventOnDayPromptCompleted(input: $input) {
      isCompleted
    }
  }
`;
export function useCheckUserEventOnDayPromptCompletedQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckUserEventOnDayPromptCompletedQuery,
    CheckUserEventOnDayPromptCompletedQueryVariables
  > &
    (
      | {
          variables: CheckUserEventOnDayPromptCompletedQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckUserEventOnDayPromptCompletedQuery,
    CheckUserEventOnDayPromptCompletedQueryVariables
  >(CheckUserEventOnDayPromptCompletedDocument, options);
}
export function useCheckUserEventOnDayPromptCompletedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckUserEventOnDayPromptCompletedQuery,
    CheckUserEventOnDayPromptCompletedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckUserEventOnDayPromptCompletedQuery,
    CheckUserEventOnDayPromptCompletedQueryVariables
  >(CheckUserEventOnDayPromptCompletedDocument, options);
}
export function useCheckUserEventOnDayPromptCompletedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckUserEventOnDayPromptCompletedQuery,
        CheckUserEventOnDayPromptCompletedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckUserEventOnDayPromptCompletedQuery,
    CheckUserEventOnDayPromptCompletedQueryVariables
  >(CheckUserEventOnDayPromptCompletedDocument, options);
}
export type CheckUserEventOnDayPromptCompletedQueryHookResult = ReturnType<
  typeof useCheckUserEventOnDayPromptCompletedQuery
>;
export type CheckUserEventOnDayPromptCompletedLazyQueryHookResult = ReturnType<
  typeof useCheckUserEventOnDayPromptCompletedLazyQuery
>;
export type CheckUserEventOnDayPromptCompletedSuspenseQueryHookResult =
  ReturnType<typeof useCheckUserEventOnDayPromptCompletedSuspenseQuery>;
export type CheckUserEventOnDayPromptCompletedQueryResult = Apollo.QueryResult<
  CheckUserEventOnDayPromptCompletedQuery,
  CheckUserEventOnDayPromptCompletedQueryVariables
>;
export function refetchCheckUserEventOnDayPromptCompletedQuery(
  variables: CheckUserEventOnDayPromptCompletedQueryVariables,
) {
  return {
    query: CheckUserEventOnDayPromptCompletedDocument,
    variables: variables,
  };
}
